import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Button, Card, Form, Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import WrapInfoDeli from '../components/WrapInfoDeli';
import '../../../../../src/styles/pages/warehouse/delivery/_index.scss';
import '../../../../../src/styles/abstracts/_variables.scss';
import { useParams } from 'react-router-dom';
import deliveryService from '@root/modules/Warehouse/Delivery/services/delivery';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { getDeliveryStatus } from '../helpers';
import { downloafFile } from '@root/modules/Sellers/Shipping/helpers';

const breadcrumbList = [
  {
    tittle: 'Delivery',
    url: '/admin/delivery'
  },
  {
    tittle: 'Detailed Delivery',
    url: ''
  }
];
const DetailDelivery = () => {
  const { idDelivery }: any = useParams();
  const [listPro, setListPro] = useState([] as any);
  // const [listDelivery, setListDelivery] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [listDetail, setListDetail] = useState([] as any);
  const [isDownload, setIsDownload] = useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);

  /*------get list delivery----------------*/
  const _getDetailDe = async () => {
    setLoading(true);
    const detialDe = await deliveryService.getDetailDelivery(idDelivery);

    if (detialDe.message === 'success') {
      setListDetail(detialDe.data);
      // const listDeliMap: any[] = [detialDe.data];
      // setListDelivery(listDeliMap);
      if (detialDe?.data?.products) {
        setListPro([...detialDe?.data?.products]);
      }
      setLoading(false);
    }
    setLoading(false);
  };
  useEffect(() => {
    _getDetailDe();
  }, []);

  const onDownloadInvoice = async () => {
    if (!idDelivery || !listDetail) {
      return;
    }
    setIsDownload(true);
    const res = await deliveryService.downloadInvoice({
      deliveryId: idDelivery,
      orderNumber: listDetail.orderNumber,
      sellerId: listDetail.sellerId
    });

    if (res.response) {
      setIsShowErrorModal(true);
      setIsDownload(false);

      return;
    }

    const sellerCompanyName = listDetail.sellerCompanyName;

    const fileName = `${sellerCompanyName ? `${sellerCompanyName}_` : ''}${
      listDetail.orderNumber
    }.pdf`;

    downloafFile(res, fileName);
    setIsDownload(false);
    setIsShowErrorModal(false);
  };

  return (
    <Spin spinning={loading}>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div className="detailDelivery">
            <div className="wrapTitle">
              <div
                className="button-wrapper"
                style={{ display: 'flex', alignItems: 'center', gap: 5 }}
              >
                <p className="updateDeli">
                  Update Date :{formatDateTime(listDetail?.updatedAt)}
                </p>
                <Button
                  type="default"
                  className="button-import"
                  onClick={onDownloadInvoice}
                  loading={isDownload}
                  size="small"
                >
                  Shipping label download
                </Button>
              </div>

              <p className="statusDe">
                <span>{getDeliveryStatus(listDetail?.status)}</span>
              </p>
            </div>
            <WrapInfoDeli
              listDetail={listDetail}
              listPro={listPro}
              _getDetailDe={_getDetailDe}
            />
          </div>
        </Card>
      </div>
      <Modal
        width={400}
        open={isShowErrorModal}
        onOk={() => {
          setIsShowErrorModal(false);
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={() => {
          setIsShowErrorModal(false);
        }}
        okButtonProps={{
          style: {
            padding: '.5rem 2.5rem',
            height: 'auto',
            border: 'none',
            borderRadius: '7.25px',
            backgroundColor: '#2B2C51',
            display: 'inline-block'
          }
        }}
        okText="확인"
        maskClosable={true}
      >
        <div>
          현재 송장을 다운로드 할 수 있는 상태가 아닙니다. Shopee 사이트를
          확인해주세요.
        </div>
      </Modal>
    </Spin>
  );
};

export default DetailDelivery;
